import corporateClean from "../../../../images/video-styles/corporate-clean.webp";
import industrialSafety from "../../../../images/video-styles/industrial-safety.webp";
import healthcareClinical from "../../../../images/video-styles/healthcare-clinical.webp";
import macroDetail from "../../../../images/video-styles/macro-detail.webp";
import aerialDrone from "../../../../images/video-styles/aerial-drone.webp";
import povFirstPerson from "../../../../images/video-styles/pov-first-person.webp";
import isometric3d from "../../../../images/video-styles/isometric-3d.webp";
import flatMotionGraphics from "../../../../images/video-styles/flat-motion-graphics.webp";
import infographicShapes from "../../../../images/video-styles/infographic-shapes.webp";
import blueprintTechnical from "../../../../images/video-styles/blueprint-technical.webp";
import claymation from "../../../../images/video-styles/claymation.webp";
import anime from "../../../../images/video-styles/anime.webp";
import watercolorStorybook from "../../../../images/video-styles/watercolor-storybook.webp";
import retro16mm from "../../../../images/video-styles/retro-16mm.webp";
import abstractTechUi from "../../../../images/video-styles/abstract-tech-ui.webp";

const THUMBS = {
  "corporate-clean": corporateClean,
  "industrial-safety": industrialSafety,
  "healthcare-clinical": healthcareClinical,
  "macro-detail": macroDetail,
  "aerial-drone": aerialDrone,
  "pov-first-person": povFirstPerson,
  "isometric-3d": isometric3d,
  "flat-motion-graphics": flatMotionGraphics,
  "infographic-shapes": infographicShapes,
  "blueprint-technical": blueprintTechnical,
  "claymation": claymation,
  "anime": anime,
  "watercolor-storybook": watercolorStorybook,
  "retro-16mm": retro16mm,
  "abstract-tech-ui": abstractTechUi,
};

export const styleThumb = (styleKey) => THUMBS[styleKey];

export const isVideoUrl = (url) => /\.(mp4|webm|mov)$/i.test((url || "").split(/[?#]/)[0]);
